/**
 * Jotai atoms for cross-component AI video signalling.
 */

import { atom } from "../app-jotai";

/**
 * Set to true by AIWeaverSidebar after diagram generation completes.
 * AIVideoButton reads it to trigger glow/tooltip nudge effect.
 */
export const diagramJustGeneratedAtom = atom(false);

/**
 * When useOneClickVideo finishes generating a video, it writes the Blob here.
 * RecordingFeature watches this atom and calls state.setFinishedVideo(),
 * which triggers the download/discard UI.
 */
export const pendingVideoBlobAtom = atom<Blob | null>(null);
